import { FC, useState } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import Button from 'jbc-front/components/Button';
import { StressCheck, Healthcare } from 'jbc-front/components/icons';
import { Item, Panel } from '@/components/PrimaryPanel';
import { useSession } from '@/components/SessionProvider';
import { useQuery } from '@/hooks/graphql/useQuery';
import { hasPermission } from '@/utils/permission';
import { ActivateModal } from './parts/ActivateModal';
import { FEATURES, FeaturesQueryResult } from './query';
import styles from './Top.scss';

export const Top: FC = () => {
  const { user } = useSession();
  const { data } = useQuery<FeaturesQueryResult>(FEATURES);
  const [isOpenActivateModal, setIsOpenActivateModal] = useState(false);

  const hasStressCheckAccess = hasPermission(user, 'stress_check_access');
  const hasRegularHealthCheckupAccess = hasPermission(user, 'regular_health_checkup_access');

  return (
    <div className={classNames('l-wrap-xs', styles.contents)}>
      {hasStressCheckAccess && (
        <Panel className={styles.panel}>
          <Item>
            <h2 className={styles.title}>
              <StressCheck className={styles.icon} size={40} />
              ストレスチェック
            </h2>
            <div className={styles.buttons}>
              <Button as={Link} to="/dashboard" primary>
                ダッシュボード
              </Button>
              <Button as={Link} to="/personal_results" primary>
                個人結果
              </Button>
              <Button as={Link} to="/group_result" primary>
                集団分析
              </Button>
            </div>
          </Item>
        </Panel>
      )}
      {!hasStressCheckAccess && data && !data.features.stressCheck && (
        <Panel className={styles.panel}>
          <Item>
            <h2 className={styles.title}>
              <StressCheck className={styles.icon} size={40} />
              ストレスチェック
            </h2>
            <div className={styles.buttons}>
              <Button primary onClick={() => setIsOpenActivateModal(true)}>
                利用開始
              </Button>
            </div>
          </Item>
        </Panel>
      )}

      {hasRegularHealthCheckupAccess && (
        <Panel className={styles.panel}>
          <Item>
            <h2 className={styles.title}>
              <Healthcare className={styles.icon} size={40} />
              定期健康診断
            </h2>
            <div className={styles.buttons}>
              <Button as={Link} to="/regular_health_checkup/personal_results" primary>
                個人結果
              </Button>
              <Button as={Link} to="/regular_health_checkup/reports" primary>
                結果報告
              </Button>
            </div>
          </Item>
        </Panel>
      )}
      {!hasRegularHealthCheckupAccess && data && !data.features.regularHealthCheckup && (
        <Panel className={styles.panel}>
          <Item>
            <h2 className={styles.title}>
              <Healthcare className={styles.icon} size={40} />
              定期健康診断
            </h2>
            <div className={styles.buttons}>
              <Button primary onClick={() => setIsOpenActivateModal(true)}>
                利用開始
              </Button>
            </div>
          </Item>
        </Panel>
      )}

      {data?.features && (
        <ActivateModal
          isOpen={isOpenActivateModal}
          onClose={() => setIsOpenActivateModal(false)}
          features={data.features}
        />
      )}
    </div>
  );
};
